export default "assets/images/icons/play-d0117e05.svg";